module.exports = __webpack_public_path__ + "ps.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ps.svg
// module id = 1023
// module chunks = 0